import { render, staticRenderFns } from "./LicitacaoVisualizacaoEsclarecimentoImpugnacao.vue?vue&type=template&id=4057831d&"
import script from "./LicitacaoVisualizacaoEsclarecimentoImpugnacao.vue?vue&type=script&lang=js&"
export * from "./LicitacaoVisualizacaoEsclarecimentoImpugnacao.vue?vue&type=script&lang=js&"
import style0 from "./LicitacaoVisualizacaoEsclarecimentoImpugnacao.vue?vue&type=style&index=0&id=4057831d&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports